import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject, takeUntil } from 'rxjs';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';
import { CapturumDropdownComponent } from '@capturum/ui/dropdown';
import { CapturumMultiSelectComponent } from '@capturum/ui/multi-select';
import { AsyncPipe } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormTooltipComponent } from '@shared/components/form-tooltip/form-tooltip.component';

@Component({
  selector: 'app-dropdown-input',
  templateUrl: './dropdown-input.component.html',
  imports: [
    ManageValidatorDisplayDirective,
    CapturumDropdownComponent,
    CapturumMultiSelectComponent,
    AsyncPipe,
    ReactiveFormsModule,
    FormTooltipComponent,
  ],
})
export class DropdownInputComponent extends FieldType implements OnInit, OnDestroy {
  private destroy = new Subject<boolean>();

  public ngOnInit(): void {
    this.formControl.valueChanges.pipe(takeUntil(this.destroy)).subscribe((value) => {
      const formGroup = this.form as FormGroup;

      formGroup.patchValue({ [this.key as string]: value }, { emitEvent: false });
    });
  }

  public ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
  }
}
